import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../../Component/Spinner';
import { AuthContext } from '../../../../contexts/AuthProvider';

const HeroBike = ({bike}) => {
    const { model, sellerLoaction, running, Engine, sellingPrice, img, _id} = bike;
    const {loading} = useContext(AuthContext);
    const navigate = useNavigate();

    const handleBikeDetails = (data) =>{
        navigate(`/bike/${_id}`, {state: data});
        console.log(data)
    }

    if(loading){
        return <Spinner></Spinner>
    }

    return (
        <div onClick={() =>handleBikeDetails(bike)} className="card card-side bg-base-100 gap-5 my-4 py-4  shadow-xl flex lg:w-2/3 w-full mx-auto  items-center">
            <figure>
                <img className='w-64 p-5 lg:mx-10' src={img} alt="Movie"/>
            </figure>
            <div className="">
                <h2 className="text-2xl font-semibold">{model}</h2>
                <p className='text-xl my-2'>{running}, {Engine}</p>
                <p className='text-xl my-2'>{sellerLoaction}</p>
                <h1 className='text-2xl font-semibold text-[#149777]'>Price: {sellingPrice} Tk</h1>
            </div>

        </div>
    );
};

export default HeroBike;